import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class configUserProfiles_template extends vnTemplate {

    protected getTemplateHtml(): string{

        return `                          
                        <div class="w-form author-setting">
                <div class="form-header">
                   <h3 class="form-title icon i-user-add">Display Job Title:</h3>
                </div>
                <div class="form-body">
                        <div class="form-group"> 
                            <input type="checkbox" id="show-author-pages" data-bind="checked: isJobTitleAuthorPagesEnabled">
                            <label for="show-author-pages" class="form-label icon i-check">Author Pages</label>   
                        </div>
                        <div class="form-group">               
                            <input type="checkbox" id="show-author-byline" data-bind="checked: isJobTitleAuthorBylineEnabled">
                            <label for="show-author-byline" class="form-label icon i-check">Author Byline</label>   
                        </div>
                        <div class="form-group">               
                            <input type="checkbox" id="show-about-author" data-bind="checked: isJobTitleAboutAuthorEnabled">
                            <label for="show-about-author" class="form-label icon i-check">About the Author</label>   
                        </div>
                </div>
            
                <div class="form-footer">
                    <button type="button" data-bind="event: { click: onClickCancel}" class="btn">Cancel</button>
                    <button type="button" data-bind="event: { click: onClickSaveAuthorSettings}" class="btn highlight">Save</button>         
                </div>                          
            </div>

            
            <div class="w-form profile-question">
                <div class="w-form-body">
                    <div class="form-header">
                       <h3 class="form-title icon i-user-add">Author Profile Questions</h3>
                    </div>
                    <div class="form-body">
                        <div class="form-group">                            
                            <div class="w-img-config-list">
                                <ul class="img-config-list" data-bind="foreach: authorDetails" id="config-item-list">
                                    <li class="img-config-item flex-row" data-bind="attr: {id: $index }">
                                        <div>
                                            <input type="checkbox" data-bind="checked: isEnabled, event: {click:$parent.onClickCheckEnabled.bind($index())}, attr: {id: 'questionDisable-checkbox-' + position}">
                                            <label data-bind="attr: {for: 'questionDisable-checkbox-' + position}" class="form-label icon i-check"></label>
                                        </div>
                                        <div class="w-info">                             
                                            <span data-bind="text: name||'Enter a Question', style: {opacity: name ? '1' : '0.3'}" class="title"></span>
                                        </div>
                                        <div class="w-btn">
                                            <button class="btn only-icon border icon i-edit" type="button" data-bind="visible: $parent.indexEditValue() == -1, event: {click: $parent.onClickShowEditValue.bind($index())}"></button>
                                        </div>
                                        
                                        <div class="form-group row" data-bind="visible: $parent.indexEditValue() == ($index()+1)">
                                            <input class="input-text" type="text" data-bind="value: $parent.editValue" placeholder="Enter a Question">
                                            <div class="w-btn">
                                                <button type="button" data-bind="event: { click: $parent.onClickCancelEdit}" class="btn only-icon border icon i-close"></button>
                                                <button type="button" data-bind="event: { click: $parent.onClickSaveEditValue}" class="btn only-icon border icon i-check"></button> 
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                                 <div class="w-left" >
                                    <button class="btn secondary icon i-add" type="button" data-bind="click: onClickAdd">Add Question</button>    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            
                <div class="form-footer">
                    <button type="button" data-bind="event: { click: onClickCancel}" class="btn">Cancel</button>
                    <button type="button" data-bind="event: { click: onClickSave}" class="btn highlight">Save</button>         
                </div>                          
            </div>

            
            `;
    }

    protected initPartial():void{

    }

    protected getTemplateName(): string{

        return "configUserProfiles_template";
    }

    protected buildViewModel(): any{

        let huit_neuf_this = this;

        return{

             authorDetails: ko.observableArray([])
            , selectedTab: ko.observable('config')
            , permissions: ko.observableArray(this.initPermissions([]))
            , editValue: ko.observable(null)
            , indexEditValue: ko.observable(-1)
            , isAddButtonShown: ko.observable(true)
            , isJobTitleAuthorPagesEnabled: ko.observable(false)
            , isJobTitleAuthorBylineEnabled: ko.observable(false)
            , isJobTitleAboutAuthorEnabled: ko.observable(false)
            ,onClickEditAuthorDetail: function (value, data, event) {huit_neuf_this.onClickEditAuthorDetail(value);}
            ,onClickShowEditValue: function(value, index, event) {huit_neuf_this.onClickShowEditValue(value)}
            ,onClickCheckEnabled: function(value, index, event) {huit_neuf_this.onClickCheckEnabled(value)}
            ,onClickSaveEditValue: function(value, index, event) {huit_neuf_this.onClickSaveEditValue()}
            ,onClickCancelEdit: function(value, index, event) {huit_neuf_this.onClickCancelEdit()}
            ,onClickSave: function(value, index, event) {huit_neuf_this.onClickSave()}
            ,onClickCancel: function(value, index, event) {huit_neuf_this.onClickCancel()}
            ,onClickAdd: function () {huit_neuf_this.onClickAdd();}
            ,onClickSaveAuthorSettings: function () {huit_neuf_this.onClickSaveAuthorSettings()}
        }
    }

    public getViewModelForRequest(){

        return{

        }
    }


    public setPermissions(permissions) {

        this.getTemplateViewModel().permissions(permissions);
    }

    public setSelectedTab(selectedTab) {

        this.getTemplateViewModel().selectedTab(selectedTab);
    }

    public setAuthorDetails(authorDetails): void{

        let arrayAuthorDetails = Object.keys(authorDetails).map(function(e){return authorDetails[e]})
        this.getTemplateViewModel().authorDetails(arrayAuthorDetails);
    }

    public setAuthorSettings(authorSettings): void{

        if(authorSettings){
            this.getTemplateViewModel().isJobTitleAuthorPagesEnabled(authorSettings.showJobTitleInAuthorPages);
            this.getTemplateViewModel().isJobTitleAuthorBylineEnabled(authorSettings.showJobTitleInAuthorByline);
            this.getTemplateViewModel().isJobTitleAboutAuthorEnabled(authorSettings.showJobTitleInAboutAuthor);
        }
    }

    protected onClickShowEditValue(value){

        this.getTemplateViewModel().editValue(value.name);
        this.getTemplateViewModel().indexEditValue(value.position);
    }

    protected onClickCheckEnabled(value){

        this.refreshAuthorDetails(this);
    }

    public onClickEditAuthorDetail(index) {

        this.caller.onClickEditAuthorDetail(index, this.getTemplateViewModel().authorDetails())
    }

    public onClickSaveEditValue(){

        if(this.getTemplateViewModel().editValue() == null || this.getTemplateViewModel().editValue() == ""){

            alert("The value cannot be blank");
            return;
        }
        let currentDetails = this.getTemplateViewModel().authorDetails();

        let indexArray = this.getTemplateViewModel().indexEditValue() - 1;
        currentDetails[indexArray].name = this.getTemplateViewModel().editValue();

        this.getTemplateViewModel().authorDetails(currentDetails);

        this.getTemplateViewModel().editValue(null);
        this.getTemplateViewModel().indexEditValue(-1);

        this.refreshAuthorDetails(this);
    }

    protected refreshAuthorDetails(huit_neuf_this){
        let authorDetails = [];
        authorDetails = huit_neuf_this.getTemplateViewModel().authorDetails();

        let selector = '#' + huit_neuf_this.idElement + ' #config-item-list .img-config-item';
        let liElements = document.querySelectorAll(selector);

        let newAuthorDetails = []
        liElements.forEach((element, index) => {

            let authorDetail = authorDetails.find((i, index) => index === Number(element.id));
            if(authorDetail){
                authorDetail.position = index + 1;
                newAuthorDetails.push(authorDetail);
            }
        });

        huit_neuf_this.getTemplateViewModel().authorDetails([]);
        huit_neuf_this.getTemplateViewModel().authorDetails(newAuthorDetails);
    }

    public onClickCancelEdit(){

        this.getTemplateViewModel().editValue(null);
        this.getTemplateViewModel().indexEditValue(-1);
    }

    public onClickSave(){

        this.caller.save();
    }

    public onClickCancel(){

        this.caller.cancelChanges();
    }

    public onClickAdd() {

        let arrayAuthorDetails = this.getTemplateViewModel().authorDetails();
        arrayAuthorDetails.push({"name": null, "position": arrayAuthorDetails.length + 1, "isEnabled": false});
        this.getTemplateViewModel().authorDetails(arrayAuthorDetails);
    }

    public onClickSaveAuthorSettings(){

        this.caller.saveAuthorSettings();
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/configUserProfiles_template.ts